import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import ReactDOM from 'react-dom';
import '../../assets/css/table.css';
var TableContainer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TableContainer, _React$PureComponent);
  var _super = _createSuper(TableContainer);
  function TableContainer(props) {
    var _this;
    _classCallCheck(this, TableContainer);
    _this = _super.call(this, props);
    _this.clearSelectedCells = function () {
      _this.table.querySelectorAll('.selected-cell').forEach(function (selectedCell) {
        selectedCell.classList.remove('selected-cell', 'selected-cell-left', 'selected-cell-bottom', 'selected-cell-top', 'selected-cell-right');
      });
    };
    _this.selectTable = function (event) {
      _this.startRowIndex = _this.getTableElement(event.target, 'tr').rowIndex;
      _this.startColIndex = _this.getTableElement(event.target, 'td').cellIndex;
      window.document.addEventListener('mousemove', _this.selectCellsInTable);
      window.document.addEventListener('mouseup', _this.onMouseUp);
    };
    _this.getTableElement = function (node, type) {
      if (node.nodeName.toLowerCase() === type) return node;
      var element = node;
      while (element.nodeName.toLowerCase() !== type) {
        element = element.parentNode;
      }
      return element;
    };
    _this.selectCellsInTable = function (event) {
      if (event.target.nodeName === 'TBODY' || !_this.table.contains(event.target)) {
        // if  event.target not in the table, clear the mouseMove event
        return;
      }
      _this.endRowIndex = _this.getTableElement(event.target, 'tr').rowIndex;
      _this.endColIndex = _this.getTableElement(event.target, 'td').cellIndex;
      var minRowIndex = Math.min(_this.startRowIndex, _this.endRowIndex),
        maxRowIndex = Math.max(_this.startRowIndex, _this.endRowIndex),
        minColIndex = Math.min(_this.startColIndex, _this.endColIndex),
        maxColIndex = Math.max(_this.startColIndex, _this.endColIndex);
      if (minRowIndex === maxRowIndex && minColIndex === maxColIndex) {
        return;
      }

      // collapse selection
      window.getSelection().collapseToEnd();
      _this.selectedRowRange = {
        min: minRowIndex,
        max: maxRowIndex
      };
      _this.selectedColRange = {
        min: minColIndex,
        max: maxColIndex
      };
      _this.hasSelectedRangeRendered = false;
      _this.forceUpdate();
    };
    _this.onMouseUp = function () {
      window.document.removeEventListener('mousemove', _this.selectCellsInTable);
      window.document.removeEventListener('mouseup', _this.onMouseUp);
    };
    _this.table = null;
    _this.selectedRowRange = {
      min: -1,
      max: -1
    };
    _this.selectedColRange = {
      min: -1,
      max: -1
    };
    _this.hasSelectedRangeRendered = false;
    return _this;
  }
  _createClass(TableContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.table = ReactDOM.findDOMNode(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$selectedRowRang = this.selectedRowRange,
        minRowIndex = _this$selectedRowRang.min,
        maxRowIndex = _this$selectedRowRang.max;
      var _this$selectedColRang = this.selectedColRange,
        minColIndex = _this$selectedColRang.min,
        maxColIndex = _this$selectedColRang.max;
      if (minColIndex < 0 || minRowIndex < 0) {
        this.clearSelectedCells();
        return;
      }
      if (this.hasSelectedRangeRendered && this.selectedRowRange.min >= 0 && this.selectedColRange.min >= 0) {
        // if selected range is selected and has rendered reset selected range
        this.selectedColRange = {
          min: -1,
          max: -1
        };
        this.selectedColRange = {
          min: -1,
          max: -1
        };
        return;
      }

      // clear previous selected style before render
      this.clearSelectedCells();
      for (var rowIndex = minRowIndex; rowIndex <= maxRowIndex; rowIndex++) {
        var selectedRow = this.table.querySelectorAll('tr')[rowIndex];
        for (var colIndex = minColIndex; colIndex <= maxColIndex; colIndex++) {
          selectedRow.querySelectorAll('td')[colIndex].classList.add('selected-cell');
          if (rowIndex === minRowIndex) {
            selectedRow.querySelectorAll('td')[colIndex].classList.add('selected-cell-top');
          }
          if (colIndex === minColIndex) {
            selectedRow.querySelectorAll('td')[colIndex].classList.add('selected-cell-left');
          }
          if (colIndex === maxColIndex) {
            selectedRow.querySelectorAll('td')[colIndex].classList.add('selected-cell-right');
          }
          if (rowIndex === maxRowIndex) {
            selectedRow.querySelectorAll('td')[colIndex].classList.add('selected-cell-bottom');
          }
        }
      }
      this.hasSelectedRangeRendered = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        attributes = _this$props.attributes,
        children = _this$props.children;
      return /*#__PURE__*/React.createElement("table", {
        onMouseDown: this.selectTable
      }, /*#__PURE__*/React.createElement("tbody", attributes, children));
    }
  }]);
  return TableContainer;
}(React.PureComponent);
export default TableContainer;